import dayjs from "dayjs";

export const COMBINED_VIEW_MAX_DAYS = 7;

const formatSince = (date, useHourly) =>
  useHourly
    ? date.format("YYYY-MM-DDTHH:mm:ss")
    : date.format("YYYY-MM-DD");

const formatUntil = (date, useHourly) =>
  useHourly
    ? date.format("YYYY-MM-DDTHH:mm:ss")
    : date.format("YYYY-MM-DD");

export const getCombinedViewAnchorEnd = (dashboardReducer) => {
  const isDynamic = Boolean(dashboardReducer?.dashboard?.RefreshRate);
  if (isDynamic) {
    return dayjs();
  }
  const end =
    dashboardReducer?.dashboard_end_date ||
    dashboardReducer?.end_date ||
    dashboardReducer?.dashboard?.end_date;
  const parsed = dayjs(end);
  return parsed.isValid() ? parsed : dayjs();
};

export const getCombinedViewDefaultRange = (dashboardReducer) => {
  const until = getCombinedViewAnchorEnd(dashboardReducer);
  const since = until.subtract(24, "hour");
  return {
    since: formatSince(since, true),
    until: formatUntil(until, true),
    daysRange: "last24",
  };
};

/**
 * Resolve Combined View dates: default last 24h, never wider than 7 days.
 */
export const resolveCombinedViewDateRange = (
  sinceStr,
  untilStr,
  dashboardReducer
) => {
  const anchorEnd = getCombinedViewAnchorEnd(dashboardReducer);
  let since = sinceStr ? dayjs(sinceStr) : null;
  let until = untilStr ? dayjs(untilStr) : null;
  let usedDefault = false;

  if (!since?.isValid() || !until?.isValid()) {
    usedDefault = true;
    until = anchorEnd;
    since = until.subtract(24, "hour");
  }

  const earliestAllowed = until
    .subtract(COMBINED_VIEW_MAX_DAYS - 1, "day")
    .startOf("day");
  let clamped = false;
  if (since.isBefore(earliestAllowed)) {
    since = earliestAllowed;
    clamped = true;
  }
  if (since.isAfter(until)) {
    since = until.subtract(24, "hour");
    clamped = true;
  }

  const useHourly = Boolean(
    usedDefault || String(sinceStr || "").includes("T")
  );

  return {
    since: formatSince(since, useHourly),
    until: formatUntil(until, useHourly),
    clamped,
    usedDefault,
  };
};

export const combinedViewDayCount = (sinceStr, untilStr) => {
  const since = dayjs(sinceStr);
  const until = dayjs(untilStr);
  if (!since.isValid() || !until.isValid()) return 0;
  const diff = until.diff(since, "day");
  return diff >= 0 ? diff + 1 : 0;
};
